import * as React from "react";
import App from "./App";
import { BrowserRouter, Route, Router, Routes } from "react-router-dom";
import * as ReactDOM from "react-dom/client";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
